export default __webpack_public_path__ + "static/pay-it-faster-video@2x-56a61b5c4a56672942f32c88634d5d4d.png";